// Kids-mode primitives — big tap targets, image-friendly, no text where
// possible. Reused across Pet / Cards / Watch / Craft tabs.
//
// EMOJI-IN-UI EXCEPTION: this tree (src/experiments/kids-mode/**) is
// the explicit opt-in to emojis per the plan. No-emoji rule still
// holds elsewhere in the app.
//
// Minimum tap target: 72px square. Anything smaller is not kid-thumb
// friendly. Font sizes (when used) >= 16px per the 12px floor + kid
// readability buffer.

import { COLOR, FONT, RADIUS } from "../../lib/tokens";
import { playKidSfx } from "../../lib/kidSfx";
import { playKidVoice } from "../../lib/kidVoice";

export function BigTapButton({ emoji, label, onClick, active = false, size = 72 }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className="mcm-focusable"
      style={{
        all: "unset",
        cursor: "pointer",
        width: size,
        height: size,
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 4,
        background: active ? COLOR.leafDeep : COLOR.ground,
        border: `2px solid ${active ? COLOR.leaf : COLOR.border}`,
        borderRadius: RADIUS.lg,
        boxShadow: active
          ? `0 4px 12px ${COLOR.leafDim}`
          : `0 2px 6px rgba(30,30,30,0.06)`,
        touchAction: "manipulation",
        transition: "background 200ms ease, border-color 200ms ease, box-shadow 200ms ease",
      }}
    >
      <span style={{ fontSize: 36, lineHeight: 1 }}>{emoji}</span>
      {label
        ? <span style={{ fontFamily: FONT.forma, fontSize: 12, fontWeight: 600, color: COLOR.ink, opacity: 0.7 }}>{label}</span>
        : null}
    </button>
  );
}

export function KidsTabBar({ active, onChange, tabs }) {
  const onTap = (id) => {
    if (id !== active) {
      playKidSfx("pop");
      // Voice announcement so a pre-reader hears the tab name
      // ("Foods!" / "Pet!" / "Watch!") as they tap. Key matches
      // the file in public/mp3/cat/<Label>.mp3. The Mix tab has
      // no clip yet — playKidVoice silently no-ops on unknown
      // keys.
      playKidVoice(id);
    }
    onChange(id);
  };
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        padding: "16px max(16px, env(safe-area-inset-left)) calc(16px + env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-right))",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        background: "linear-gradient(180deg, rgba(250,246,238,0) 0%, rgba(250,246,238,0.92) 35%, rgba(250,246,238,1) 100%)",
        pointerEvents: "auto",
        zIndex: 100,
      }}
    >
      {tabs.map((tab) => (
        <BigTapButton
          key={tab.id}
          emoji={tab.emoji}
          label={tab.label}
          active={active === tab.id}
          onClick={() => onTap(tab.id)}
          size={76}
        />
      ))}
    </div>
  );
}
